export default "__VITE_ASSET__DhKf4vUT__"